<div [ngClass]="item.is_selected ? 'selected-food ' : 'unselected-food'">
    <div class="innerCard rowRight">
        <div class="mcol effecting">
            <!-- <div class="effector menuBgin">
                 <div #backgroundLayer class="effector menuBginImg"></div>
            </div> -->
            <img class="effector selImg" [src]="item.attachment ? item.attachment : '../../assets/dummy.png'" (click)="onMenuDetailPage()"/>
<!-- (click)="onMenuDetailPage(item)" -->
                <div class="mealCounter">

                    <div class="counterBg"></div>

                    <div #foregroundLayer class="addCounter effector" (click)="onMinusClick()">
                        <ion-icon class="smallIcon" src="../../assets/svg/minus.svg"></ion-icon>
                    </div>

                    <div #foregroundLayer class="itemCount effector">{{ item.quantity }}</div>

                    <div #foregroundLayer class="minusCounter effector" (click)="onPlusClick()">
                        <ion-icon class="smallIcon" src="../../assets/svg/plus.svg"></ion-icon>
                    </div>
                </div>

                <div class="typeTag">
              
                <div class="mealType" *ngIf="!item?.price;">
                    <div class="mealText">
                        {{ item.food_type_category === 'meal' ? ('meals' | translate) : ('snacks' | translate) }}
                    </div>
                    &nbsp;
                    <span *ngIf="item?.selection_number && item.selection_number != '0' && item.food_type_category === 'meal' && item.is_selected">
                        {{ item?.selection_number }}
                    </span>
                </div>
                </div>

        </div>
<!-- (click)="onSelectFoodMenu()" -->
        <div class="contentInner rowRight" (click)="onSelectFoodMenu()">
            <div class="itemDetails" >
                <div class="itemText">
              
                    <div class="title">
                        {{ appL === 'ar' ? getShortTitle(item.a_name) : getShortTitle(item.name) }}
                    </div>
                    <div class="desc">
                        {{ appL === 'ar' ? getShortDesc(item.a_description) : getShortDesc(item.description) }}
                    </div>
                </div>
                  <div class="price" *ngIf="item?.price;">
                            {{item.price | number:'1.3-3'}} KWD
                </div>
                 <!-- <app-nutrition-card *ngIf="!item?.price;" [macros]="item"></app-nutrition-card>  -->
                <macros-bar *ngIf="!item?.price;" [item]="item" color="primary"></macros-bar>
            </div>
<div class="scaledCarbSelector" *ngIf="showScaledCarbSelector" (click)="$event.stopPropagation()">
            <div class="carbSelectorLabel">
                {{ 'carbs' | translate }}
            </div>
            <div class="carbOptions">
                <div 
                    *ngFor="let carbValue of scaledCarbOptions" 
                    class="carbOption"
                    [class.selected]="isScaledCarbSelected(carbValue)"
                    (click)="onScaledCarbSelect(carbValue)">
                    {{ carbValue }}g
                </div>
            </div>
        </div>
        </div>

        <!-- Scaled Carb Selector -->
        
    </div>
 
</div>